<template>
  <div class="securitydetails">
    <div class="header">
      <div class="title">安防系统详情</div>
      <div class="border"></div>
    </div>

    <div class="list">
      <div class="item" v-for="item in securitydetailsList" :key="item.id">
        <img :src="item.logo" alt="" />
        <div>{{ item.title }}</div>
      </div>
    </div>

    <div class="body">
      <div class="left">
        <div class="title">远程视频监控</div>
        <div class="text">
          远程用户收到警情电话、信息后可以通过上网手机或电脑查看监控画面情况，并通过手机控制摄像机旋转角度及焦距、报警系统布防撤防，同时启动手机录像功能并处理警情
        </div>
        <div class="list-1">
          <div class="item-1" v-for="item in list1" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <img :src="securitydetailsLogo1" alt="" />
      </div>
    </div>

    <div class="body1">
      <div class="left">
        <img :src="securitydetailsLogo2" alt="" />
      </div>
      <div class="right">
        <div class="title">门禁系统</div>
        <div class="text">
          与智能监控系统链接使用，提高安防质量，减少安全隐患
        </div>
        <div class="list-1">
          <div class="item-1" v-for="item in list2" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="body" style="margin-bottom: 80px">
      <div class="left">
        <div class="title">智能巡更</div>
        <div class="text">
          电子巡更管理系统是安防中的必备系统，因为没有任何电子技防设备可以取代保安，而保安最主要的安全防范工作就是巡更。
        </div>
        <div class="list-1">
          <div class="item-1" v-for="item in list3" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <img :src="securitydetailsLogo3" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import securitydetailsList1 from "../../../../assets/programme/securitydetailsList1.png";
import securitydetailsList2 from "../../../../assets/programme/securitydetailsList2.png";
import securitydetailsList3 from "../../../../assets/programme/securitydetailsList3.png";
import securitydetailsList4 from "../../../../assets/programme/securitydetailsList4.png";
import securitydetailsList5 from "../../../../assets/programme/securitydetailsList5.png";

import securitydetailsLogo1 from "../../../../assets/programme/securitydetailsLogo1.png";
import securitydetailsLogo2 from "../../../../assets/programme/securitydetailsLogo2.png";
import securitydetailsLogo3 from "../../../../assets/programme/securitydetailsLogo3.png";

import securitydetails1 from "../../../../assets/programme/securitydetails1.png";
import securitydetails2 from "../../../../assets/programme/securitydetails2.png";
import securitydetails3 from "../../../../assets/programme/securitydetails3.png";
import securitydetails4 from "../../../../assets/programme/securitydetails4.png";
import securitydetails5 from "../../../../assets/programme/securitydetails5.png";
import securitydetails6 from "../../../../assets/programme/securitydetails6.png";
import securitydetails7 from "../../../../assets/programme/securitydetails7.png";
import securitydetails8 from "../../../../assets/programme/securitydetails8.png";
import securitydetails9 from "../../../../assets/programme/securitydetails9.png";
import securitydetails10 from "../../../../assets/programme/securitydetails10.png";

export default {
  setup() {
    return reactive({
      securitydetailsList: [
        {
          id: 1,
          title: "远程监控",
          logo: securitydetailsList1,
        },
        {
          id: 2,
          title: "门禁系统",
          logo: securitydetailsList2,
        },
        {
          id: 3,
          title: "入侵警报系统",
          logo: securitydetailsList3,
        },
        {
          id: 4,
          title: "社区危险预警监控",
          logo: securitydetailsList4,
        },
        {
          id: 5,
          title: "视频巡更系统",
          logo: securitydetailsList5,
        },
      ],
      securitydetailsLogo1: securitydetailsLogo1,
      securitydetailsLogo2: securitydetailsLogo2,
      securitydetailsLogo3: securitydetailsLogo3,
      list1: [
        {
          id: 1,
          title: "AI算法",
          logo: securitydetails1,
        },
        {
          id: 2,
          title: "提前预警",
          logo: securitydetails2,
        },
        {
          id: 3,
          title: "消息推送",
          logo: securitydetails3,
        },
      ],
      list2: [
        {
          id: 1,
          title: "安全防控",
          logo: securitydetails4,
        },
        {
          id: 2,
          title: "AI智能算法",
          logo: securitydetails5,
        },
        {
          id: 3,
          title: "灵活便捷",
          logo: securitydetails6,
        },
        {
          id: 4,
          title: "出入记录自动保存",
          logo: securitydetails7,
        },
      ],
      list3: [
        {
          id: 1,
          title: "自动生成计划",
          logo: securitydetails8,
        },
        {
          id: 2,
          title: "自动执行",
          logo: securitydetails9,
        },
        {
          id: 3,
          title: "提前预警",
          logo: securitydetails10,
        },
      ],
    });
  },
};
</script>

<style scoped>
.securitydetails {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.list {
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
}
.list .item {
  position: relative;
  overflow: hidden;
}
.list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.list .item img {
  width: 220px;
}
.list .item div {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
  padding: 16px 0;
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.body {
  margin-top: 80px;
  display: flex;
  justify-content: space-between;
}
.body .right img {
  width: 600px;
}
.body .left {
  width: 500px;
}
.body .left .title {
  font-size: 16px;
  color: #333;
}
.body .left .text {
  margin-top: 20px;
  font-size: 14px;
  color: #495a6c;
}
.body .left .list-1 {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}
.body .left .list-1 .item-1 {
  text-align: center;
}
.body .left .list-1 .item-1 img {
  width: 36px;
}
.body .left .list-1 .item-1 div {
  font-size: 18px;
  margin-top: 20px;
}

.body1 {
  margin-top: 80px;
  display: flex;
  justify-content: space-between;
}
.body1 .left img {
  width: 600px;
}
.body1 .right {
  width: 500px;
}
.body1 .right .title {
  font-size: 16px;
  color: #333;
}
.body1 .right .text {
  margin-top: 20px;
  font-size: 14px;
  color: #495a6c;
}
.body1 .right .list-1 {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}
.body1 .right .list-1 .item-1 {
  text-align: center;
}
.body1 .right .list-1 .item-1 img {
  width: 36px;
}
.body1 .right .list-1 .item-1 div {
  font-size: 18px;
  margin-top: 20px;
}
</style>
